import { ImportedNgModuleProviders, inject, Provider, provideEnvironmentInitializer } from '@angular/core';
import {Store} from '@softline/core';
import {SOFTLINE_FEATURE_TRANSLATION, TranslationStore} from '@softline/ui-core';
import {default as de} from '../i18n/de.json';
import {ApplicationStore, SOFTLINE_FEATURE_APPLICATIONS} from '@softline/application';

export const wiegungProviders: (Provider | ImportedNgModuleProviders)[] =
  [
    provideEnvironmentInitializer(async () => {
        const store = inject(Store);

        store.commit(
          SOFTLINE_FEATURE_TRANSLATION,
          TranslationStore.mutations.add,
          {
            module: 'wiegung',
            language: 'de',
            translations: de,
          }
        );

        store.commit(
          SOFTLINE_FEATURE_APPLICATIONS,
          ApplicationStore.mutations.add,
          {
            name: 'Wiegung',
            route: '/wiegung',
            icon: 'fa-regular fa-scale-balanced',
            //permission: SOFTLINE_PERMISSION_GOLDSCHMIEDE
          }
        );
      }),
  ];
